module.exports = __webpack_public_path__ + "img/text.1fb20d83.png";